import React from 'react'
import styled from '@emotion/styled'

import useMyProductFormContext from '@src/hooks/product/form/useProductFormContext'

import SectionBlock from './SectionBlock'
import SkuTableRow from './SkuTableRow'

const SkuTable = () => {
	const { getSkuTableProps } = useMyProductFormContext()
	const { isOptionExist, variants, variantOptions } = getSkuTableProps()

	if (!isOptionExist) return null

	const horizVariant = variants[0]
	const vertVariant = variants[1]
	const horizOptions = variantOptions.filter((option) => {
		return option.variantDepth === 1
	})
	const vertOptions = variantOptions.filter((option) => {
		return option.variantDepth === 2
	})

	return (
		<SectionBlock title="상품 옵션별 가격 및 재고량 설정">
			<Block>
				<TableBlock>
					{vertVariant && (
						<VertTitleGroup>
							<Spacer />
							<VertVariantBlock>
								<VertVariant>
									{vertVariant.name
										? `${vertVariant.name.split('').join('\n')}`
										: `옵션명•2`.split('').join('\n')}
								</VertVariant>
								<VertOptionTitleBlock>
									{vertOptions.map((option) => (
										<VertOptionTitle key={`vert-option-title-${option.cno}`}>
											{option.name
												? `${option.name.split('').join('\n')}`
												: `옵션명을 입력해주세요`.split('').join('\n')}
										</VertOptionTitle>
									))}
								</VertOptionTitleBlock>
							</VertVariantBlock>
						</VertTitleGroup>
					)}

					<TableDataBlock>
						<TableBody>
							<HorizontalVariant>
								{horizVariant.name ? horizVariant.name : '옵션명•1'}
							</HorizontalVariant>
							<HorizOptionTitleBlock>
								{horizOptions.map((option) => (
									<HorizOptionTitle key={`horiz-option-title-${option.cno}`}>
										{option.name ? option.name : `옵션명을 입력해주세요.`}
									</HorizOptionTitle>
								))}
							</HorizOptionTitleBlock>
							{Array.isArray(vertOptions) && vertOptions.length > 0 ? (
								vertOptions.map((option, index) => {
									return (
										<SkuTableRow
											key={`sku-row-no-${option.cno}`}
											horizOptions={horizOptions}
											vertOption={option}
											startIndex={index * horizOptions.length}
										/>
									)
								})
							) : (
								<SkuTableRow horizOptions={horizOptions} startIndex={0} />
							)}
						</TableBody>
					</TableDataBlock>
				</TableBlock>
			</Block>
		</SectionBlock>
	)
}

const Block = styled.div`
	display: flex;
	width: 100rem;
	margin-top: 2rem;
	overflow-x: scroll;
	overflow-y: hidden;
`

const TableBlock = styled.div`
	display: flex;
`

const VertTitleGroup = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 8rem;
	height: 100%;
`

const VertVariantBlock = styled.div`
	display: flex;
	height: 100%;
`

const VertOptionTitleBlock = styled.div`
	display: flex;
	flex-direction: column;
	width: 3rem;
	border-bottom: 1px solid #000;
`

const VertOptionTitle = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 24.5rem;
	width: 100%;
	border-top: 1px solid #000;
	white-space: pre-wrap;
	font-size: 1.2rem;
	font-weight: 500;
	line-height: 1.5rem;
	overflow: hidden;
`

const HorizOptionTitleBlock = styled.div`
	display: flex;
	width: 100%;
`

const HorizOptionTitle = styled.div`
	min-width: 27rem;
	text-align: center;
	border-bottom: 1px solid #000;
	border-left: 1px solid #000;
	padding: 1rem 0;
	font-size: 1.2rem;
	font-weight: 500;
	&:last-child {
		border-right: 1px solid #000;
	}
`

const HorizontalVariant = styled.div`
	text-align: center;
	background: #dbdbdb;
	padding: 1.5rem 0;
	border-radius: 0.4rem 0.4rem 0 0;
	width: 100%;
	font-size: 1.4rem;
	font-weight: 600;
	border: 1px solid;
`

const Spacer = styled.div`
	background-color: inherit;
	height: 7.8rem;
	min-height: 7.8rem;
`

const VertVariant = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #dbdbdb;
	height: 100%;
	font-size: 1.4rem;
	font-weight: 600;
	white-space: pre-wrap;
	border-radius: 0.4rem 0 0 0.4rem;
	border: 1px solid;
	border-right: 0;
	padding: 0 2rem;
	text-align: center;
`

const TableDataBlock = styled.div`
	display: flex;
`

const TableBody = styled.div`
	display: flex;
	flex-direction: column;
`

export default SkuTable
